import Cookies from "js-cookie";

const LATEST_COOKIE_NAME = "BITRIX_SM_LATEST_TOURS";
const SEPARATOR = ";";
const MAX_ITEMS = 16;

export const getLatestToursIds = (...ignore) => {
  return (
    Cookies.get(LATEST_COOKIE_NAME)
      ?.split(SEPARATOR)
      .filter((id) => id && !ignore.includes(id)) || []
  );
};

export const updateLatestToursIds = (...ids) => {
  Cookies.set(
    LATEST_COOKIE_NAME,
    Array.from(new Set(ids.concat(getLatestToursIds())))
      .slice(0, MAX_ITEMS)
      .join(SEPARATOR),
    { expires: 365 }
  );
};
